import { useGlobalSearchParams } from "expo-router";
import { useRef } from "react";

export function useCampaignLink(): Record<
  "userResearchCohortTag",
  string | null
> {
  const { uxr } = useGlobalSearchParams<{ uxr?: string }>();
  const uxrValue = useRef<string | null>(null);

  if (uxr && !uxrValue.current) {
    uxrValue.current = uxr;
  }

  return { userResearchCohortTag: uxrValue.current };
}
